var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "pdp-purchase-form",
      class: { "is-flashing": _vm.isFlashing },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submit($event)
        }
      }
    },
    [
      !_vm.canShowButtonLink
        ? _c(
            "div",
            [
              _vm.showPurchaseOptions
                ? _c("PurchaseOptions")
                : _c("OneTimePurchaseLabel")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isOutOfStock && !_vm.canShowButtonLink
        ? _c("footer", [
            _c("p", { staticClass: "pdp-purchase-form-error-message" }, [
              _c(
                "a",
                {
                  staticClass: "button pdp-purchase-form-out-of-stock-button",
                  attrs: { id: "BIS_trigger", href: "#" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.translations.outOfStock) +
                      "\n      "
                  )
                ]
              )
            ])
          ])
        : _c(
            "footer",
            [
              _vm.quantitySelector.type === "dropdown"
                ? _c("QuantitySelectorDropdown", {
                    attrs: {
                      quantity: _vm.quantity,
                      multiplier: _vm.quantitySelector.multiplier,
                      "singular-text-raw": _vm.quantitySelector.textSingularRaw,
                      "plural-text-raw": _vm.quantitySelector.textPluralRaw,
                      "inventory-quantity": _vm.inventoryQuantity
                    },
                    on: { change: _vm.setQuantity }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.quantitySelector.type === "incremental" &&
              !_vm.canShowButtonLink
                ? _c("QuantitySelectorIncremental", {
                    attrs: {
                      quantity: _vm.quantity,
                      multiplier: _vm.quantitySelector.multiplier,
                      "inventory-quantity": _vm.inventoryQuantity
                    },
                    on: { change: _vm.setQuantity }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.canShowButtonLink
                ? _c("ButtonLink", {
                    attrs: {
                      href: _vm.linkTo,
                      text: _vm.translations.addToCart
                    }
                  })
                : _c("PurchaseButton", {
                    class: { "button-disabled": _vm.hasNotEnoughStock }
                  })
            ],
            1
          ),
      _vm._v(" "),
      _vm.hasNotEnoughStock
        ? _c("p", { staticClass: "pdp-purchase-form-error-message" }, [
            _vm._v("\n    " + _vm._s(_vm.translations.notEnoughStock) + "\n  ")
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }